/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchRolesResponse
 */
export interface SearchRolesResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchRolesResponse
     */
    roles: Array<string>;
}

/**
 * Check if a given object implements the SearchRolesResponse interface.
 */
export function instanceOfSearchRolesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "roles" in value;

    return isInstance;
}

export function SearchRolesResponseFromJSON(json: any): SearchRolesResponse {
    return SearchRolesResponseFromJSONTyped(json, false);
}

export function SearchRolesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRolesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'roles': json['roles'],
    };
}

export function SearchRolesResponseToJSON(value?: SearchRolesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'roles': value.roles,
    };
}

